import { ReactNode } from "react";
import styles from "./CallToAction.module.css";

export interface CallToActionProps {
  heading: string;
  description: ReactNode;
  children: ReactNode;
}

const CallToAction = ({
  heading,
  description,
  children,
}: CallToActionProps) => (
  <div className={styles.headerWrapper}>
    <div className={styles.callToActionContainer}>
      <h3 className={styles.headingText}>{heading}</h3>
      {description != null && <div>{description}</div>}
    </div>
    <div className={styles.buttonWrapper}>{children}</div>
  </div>
);

export default CallToAction;
